import React from 'react';
import PropTypes from 'prop-types';

import BundleProductCard from 'Features/Bundle/components/Cards/BundleProductCard';
import FourCardRow from 'Features/Bundle/components/Templates/GridTemplates/FourCardRow';

export default function DlcBundle({
  filteredBundleTier,
  switchCarouselGame,
  templateType,
}) {
  return (
    <React.Fragment>
      <div className="fan-grid-container dlc-template">
        <div className="two-column-row main-game-container">
          {filteredBundleTier.slice(0, 1).map(product =>
            <div key={product._id}>
              <BundleProductCard
                bigCard
                product={product}
                switchCarouselGame={switchCarouselGame}
                sizesOverride="(min-width: 1520px) 645px, (min-width: 1200px) 550px, (min-width: 992px) 460px, (min-width: 768px) 340px, (min-width: 576px) 255px, 50vw"
              />
            </div>,
          )}
        </div>
        <div className="two-column-row dlc-cards-container">
          <div className="fan-grid-container">
            {filteredBundleTier.slice(1, 5).map((product, i) => {
              const index = i + 1;
              return (
                <div className="two-column-row" key={product._id + index}>
                  <BundleProductCard
                    product={product}
                    switchCarouselGame={switchCarouselGame}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="fan-grid-container justify-content-start">
        <FourCardRow
          filteredBundleTier={filteredBundleTier.slice(5)}
          switchCarouselGame={switchCarouselGame}
          templateType={templateType}
        />
      </div>
    </React.Fragment>
  );
}

DlcBundle.propTypes = {
  filteredBundleTier: PropTypes.arrayOf(PropTypes.shape({})),
  switchCarouselGame: PropTypes.func,
  templateType: PropTypes.string,
};

DlcBundle.defaultProps = {
  filteredBundleTier: [],
  switchCarouselGame: () => { },
  templateType: 'standard',
};
